module.exports = __webpack_public_path__ + "media/hksong.e88bcf51.mp3";